export const allergenData = [
	"Dairy",
	"Eggs",
	"Peanuts",
	"Nuts (not otherwise listed)",
	"Seafood",
	"Shellfish",
	"Soy",
	"Wheat",
	"Melons, bananas, cucumbers",
	"Bakers yeast",
	"Agar ",
	"Almond oil",
	"Apple pectin",
	"Artichoke ",
	"Aspartame ",
	"Eggplant",
	"Avocado",
	"Banana ",
	"Beef ",
	"Bilberries ",
	"Blueberries",
	"Cantaloupe",
	"Carob",
	"Carrot",
	"Chocolate",
	"Cinnamon",
	"Citric acid ",
	"Coconut",
	"Coriander leaf ",
	"Corn oil",
	"Corn syrup",
	"Cornflour ",
	"Fish",
	"Fruit",
	"Garlic",
	"Gelatin",
	"Ginger ",
	"Grapes ",
	"Green beans",
	"Iodine AND/OR iodine compound ",
	"Kiwi fruit ",
	"Lemons",
	"Lima beans",
	"Mineral oil ",
	"Omega 3 fatty acids",
	"Oats",
	"Oil of ginger",
	"Papaya and derivative",
	"Pectin ",
	"Pepper",
	"Pepper - seasoning",
	"Peppermint",
	"Pork",
	"Potassium citrate",
	"Potato",
	"Poultry ",
	"Protein supplement",
	"Red kidney beans ",
	"Red Meat",
	"Root beer",
	"Rye",
	"Saccharin ",
	"Seed",
	"Sesame oil ",
	"Sheep products",
	"Squash",
	"Strawberry ",
	"Tomato",
	"Tryptophan ",
	"Vanilla",
	"Wheatgerm oil ",
	"Food coloring ",
	"Potassium metabisulfite ",
	"Sodium benzoate ",
	"Sodium metabisulfite ",
	"Sorbic acid ",
	"Sorbitol ",
	"Wine ",
	"Corn",
	"Soybean (soy protein)",
	"Egg whites (egg protein)",
	"Coffee",
	"Onion",
	"Gluten",
	"Dried egg",
	"Raw egg",
	"Dried egg white",
	"Egg yolk",
	"Egg white",
	"Hen's egg",
	"Egg protein",
	"Egg product",
	"Alcoholic beverages ",
	"Spicy foods",
	"Caffeine",
	"Citrus",
	"Fatty foods",
	"House dust",
	"Pollen",
	"Animal Dander",
	"Mite",
	"Insect",
	"Latex",
	"Nickel",
	"Mold (Inhaled)",
	"Animal skin cells",
	"Anthralin",
	"Animal serum protein ",
	"Animal urine protein ",
	"Arnica extract ",
	"Benzalkonium chloride",
	"Suture ",
	"Anhydrous lanolin ",
	"Azelaic acid",
	"Benzalkonium",
	"Benzethonium",
	"Benzoic acid",
	"Benzoyl peroxide ",
	"Benzyl alcohol",
	"Coal tar",
	"Floor wax",
	"Hair dye",
	"Lanolin ",
	"Methylbenzethonium chloride ",
	"Phenol ",
	"Polycarbonate",
	"Silk",
	"Witch hazel ",
	"Wool",
	"Deer fly bite ",
	"Insect debris",
	"Clostridium botulinum toxin ",
	"Diphtheria toxin",
	"Haemophilus antibody",
	"Microbial antigen ",
	"Staphylococcus species antibody ",
	"Streptococcus species antibody ",
	"3-tree-Pharmacia pollen mix ",
	"6-grass Pharmacia pollen mix ",
	"Acacia pollen ",
	"Alder pollen ",
	"American beech pollen ",
	"Ash pollen ",
	"Aster pollen ",
	"Australian pine pollen ",
	"Bahia grass pollen ",
	"Beech pollen ",
	"Bent grass pollen ",
	"Bermuda grass pollen ",
	"Blue-green algae product",
	"Box elder pollen ",
	"Brome grass pollen ",
	"Cajeput tree pollen ",
	"Canary grass pollen ",
	"Cedar pollen ",
	"Chrysanthemum pollen ",
	"Cocklebur pollen ",
	"Cocksfoot grass pollen ",
	"Common pigweed pollen ",
	"Common reed pollen ",
	"Common sorrel pollen ",
	"Cottonwood pollen ",
	"Couch grass pollen ",
	"Cultivated oat pollen ",
	"Cultivated rye pollen ",
	"Cultivated wheat pollen ",
	"Cypress pollen ",
	"Dahlia pollen ",
	"Daisy pollen ",
	"Dandelion pollen ",
	"Dock pollen ",
	"Dog's tail grass pollen ",
	"Douglas fir pollen ",
	"Elder pollen ",
	"Elm pollen ",
	"English plantain pollen ",
	"Eucalyptus pollen ",
	"False ragweed pollen ",
	"Fir pollen ",
	"Firebrush pollen ",
	"Flower and weed pollen ",
	"Giant ragweed pollen ",
	"Golden rod pollen ",
	"Grass pollen ",
	"Gray elder pollen ",
	"Hazel pollen ",
	"Hop pollen ",
	"Hornbeam pollen ",
	"Italian cypress pollen ",
	"Japanese cedar pollen ",
	"Japanese cypress pollen ",
	"Japanese hop pollen ",
	"Johnson grass pollen ",
	"June grass pollen ",
	"Juniper pollen ",
	"Kentucky blue grass pollen ",
	"Lamb's quarters pollen ",
	"Lilac pollen",
	"Lime pollen ",
	"Linden pollen ",
	"Maple pollen ",
	"Meadow fescue pollen ",
	"Meadow foxtail pollen ",
	"Meadow grass pollen ",
	"Mesquite pollen ",
	"Mugwort pollen ",
	"Nettle pollen ",
	"Oak pollen ",
	"Olive pollen ",
	"Orchard grass pollen ",
	"Ox-eye daisy pollen ",
	"Palm pollen ",
	"Pecan pollen ",
	"Pellitory pollen ",
	"Pigweed pollen ",
	"Pine pollen ",
	"Plane pollen ",
	"Ponderosa pine pollen ",
	"Poplar pollen ",
	"Ragweed pollen ",
	"Rape pollen ",
	"Rough marshelder pollen ",
	"Rough pigweed pollen ",
	"Russian thistle pollen ",
	"Rye grass pollen ",
	"Scale pollen ",
	"Scots pine pollen ",
	"Sheep sorrel pollen ",
	"Silver birch pollen ",
	"Snakeweed pollen ",
	"Spruce pollen ",
	"Sweet vernal pollen ",
	"Sycamore pollen ",
	"Thistle pollen ",
	"Timothy grass pollen ",
	"Tree and shrub pollen ",
	"Velvet grass pollen ",
	"Wall pellitory pollen ",
	"Walnut pollen ",
	"White ash pollen ",
	"White pine pollen ",
	"Wild rye grass pollen ",
	"Willow pollen ",
	"Wormwood pollen ",
	"Zea mays pollen ",
	"Ammonium chloride",
	"Cresol and derivatives",
	"gamma Benzene hexachloride ",
	"Mercury AND/OR mercury compound ",
	"Molybdenum AND/OR molybdenum compound ",
	"Phthalic acid ester ",
	"Piperonyl butoxide ",
	"Platinum AND/OR platinum compound ",
	"Silicon",
	"Silk waste ",
	"Silver ",
	"Vanadium AND/OR vanadium compound ",
	"Cat dander",
	"Dog dander",
	"Tree pollen",
	"Weed pollen",
	"Shampoo",
	"Bee venom",
	"Methimazole",
	"Nortriptyline (Nortriptyline Hydrochloride)",
	"Mineral Oil Light",
	"Methylene Blue",
	"Acepromazine Maleate",
	"Chlorhexidine Acetate",
	"Sodium Chloride",
	"Potassium Permanganate",
	"Nitrobenzene",
	"Tylosin (Tylosin Tartrate)",
	"Papaverine Hydrochloride",
	"Simethicone",
	"Magnesium Hydroxide",
	"Dimenhydrinate",
	"Lidocaine",
	"Lidocaine Hydrochloride",
	"Succinylcholine Chloride",
	"Dactinomycin",
	"Atropine Sulfate",
	"Dexamethasone",
	"Tropicamide",
	"Pentobarbital Sodium",
	"Penicillamine",
	"Quinine Sulfate",
	"Hydroxyzine Hydrochloride",
	"Betamethasone (Betamethasone Sodium Phosphate)",
	"Phenobarbital",
	"Dihydroergotamine Mesylate",
	"Medroxyprogesterone Acetate",
	"Bacitracin",
	"Hydrocortisone",
	"Prednisone",
	"Oxyquinoline Sulfate",
	"Chlorpheniramine Maleate",
	"Epinephrine (Epinephrine Bitartrate)",
	"Oxytocin",
	"Tylosin",
	"Phenytoin",
	"Docusate Sodium",
	"Flumethasone Pivalate",
	"Sulfamethazine Sodium",
	"Piperazine Hydrochloride",
	"Mineral Oil",
	"Clidinium Bromide",
	"Ethosuximide",
	"Thyroid",
	"Carbamazepine",
	"Hydrochlorothiazide",
	"Epinephrine",
	"Methylprednisolone Acetate",
	"Hypromellose",
	"Methylphenidate Hydrochloride",
	"Gentamicin (Gentamicin Sulfate)",
	"Potassium Iodide",
	"Clioquinol",
	"Vitamin E (D-Alpha Tocopheryl Acetate)",
	"Codeine Phosphate",
	"Butalbital",
	"Clindamycin (Clindamycin Hydrochloride)",
	"Nitroglycerin",
	"Iothalamate Meglumine",
	"Amphotericin B",
	"Naphazoline Hydrochloride",
	"Procarbazine (Procarbazine Hydrochloride)",
	"Epinephrine (Epinephrine Hydrochloride)",
	"Doxepin (Doxepin Hydrochloride)",
	"Busulfan",
	"Mercaptopurine",
	"Phenytoin Sodium",
	"Prednisolone",
	"Bismuth Dipropylacetate",
	"Chlorobutanol",
	"Ampicillin (Ampicillin Trihydrate)",
	"Methylprednisolone (Methylprednisolone Sodium Succinate)",
	"Dl-Methionine",
	"Proparacaine Hydrochloride",
	"Mannitol",
	"Azathioprine",
	"Chlorambucil",
	"Melphalan",
	"Ketamine (Ketamine Hydrochloride)",
	"Clindamycin (Clindamycin 2-Palmitate Hydrochloride)",
	"Acetylsalicylic Acid",
	"Testosterone Enanthate",
	"Chlorpromazine (Chlorpromazine Hydrochloride)",
	"Thymol Iodide",
	"Piperazine Dihydrochloride",
	"Lithium Carbonate",
	"Sulfanilamide",
	"Aluminum Chlorohydrate",
	"Methylprednisolone",
	"Testosterone Cypionate",
	"Norethindrone Acetate",
	"Spironolactone",
	"Fluorometholone",
	"Ethambutol Hydrochloride",
	"Phenylbutazone",
	"Cyclopentolate Hydrochloride",
	"Bisacodyl",
	"Propylene Glycol",
	"Betamethasone Acetate",
	"Vitamin A",
	"Sulfamethazine",
	"Clindamycin (Clindamycin Phosphate)",
	"Calcium Chloride",
	"Estradiol Benzoate",
	"Protease",
	"Coal Tar",
	"Triclosan",
	"Sodium Lactate",
	"Magnesium Chloride (Magnesium Chloride Hexahydrate)",
	"Dextrose",
	"Hyoscyamine Sulfate",
	"Cortisone Acetate",
	"Thioguanine",
	"Tetracycline Hydrochloride",
	"Calcium Hydroxide",
	"Sodium Bicarbonate",
	"Phenol",
	"Glycerine",
	"Non Pollen",
	"Ethinyl Estradiol",
	"Pyrantel (Pyrantel Pamoate)",
	"Colchicine",
	"Prednisolone Acetate",
	"Tetracosactide",
	"Dexamethasone (Dexamethasone Sodium Phosphate)",
	"Clomipramine Hydrochloride",
	"Sulfathiazole",
	"Betamethasone (Betamethasone Dipropionate)",
	"Purified Protein Derivative Of Tuberculin",
	"Nitrofurantoin",
	"Nitrofurazone",
	"Sulfathiazole Sodium",
	"Fluorouracil",
	"Silver Sulfadiazine",
	"Camphor",
	"Carmustine",
	"Benzylpenicilloyl-Polylysine",
	"Magnesium Stearate",
	"Aluminum Sodium Sulfate",
	"Edetic Acid",
	"Trifluoperazine (Trifluoperazine Hydrochloride)",
	"Imipramine Hydrochloride",
	"Amitriptyline Hydrochloride",
	"Hydrocortisone (Hydrocortisone Sodium Succinate)",
	"Cloxacillin (Cloxacillin Sodium)",
	"Furosemide",
	"Perphenazine",
	"Pilocarpine Hydrochloride",
	"Polymyxin B Sulfate",
	"Chlorthalidone",
	"Methyldopa",
	"Hyoscine Butylbromide",
	"Potassium Chloride",
	"Lomustine",
	"Sodium Carbonate (Anhydrous)",
	"Clonazepam",
	"Iodine (Ethiodized Oil)",
	"Diazepam",
	"Dinoprostone",
	"Benserazide (Benserazide Hydrochloride)",
	"Mepivacaine Hydrochloride",
	"Corbadrine",
	"Primidone",
	"Guaiacol Carbonate",
	"Chloramphenicol (Chloramphenicol Sodium Succinate)",
	"Morantel Tartrate",
	"Capsicum Oleoresin",
	"Fluphenazine Hydrochloride",
	"Rifampin",
	"Benzalkonium Chloride",
	"Phosphoric Acid",
	"Yellow Fever Vaccine",
	"Pneumococcal Polysaccharide Serotype 7f",
	"Folic Acid",
	"Alcohol Anhydrous",
	"Morphine Sulfate",
	"Magnesium Sulfate",
	"Pindolol",
	"Valproic Acid (Sodium Valproate)",
	"Bismuth Subgallate",
	"Timolol (Timolol Maleate)",
	"Amoxicillin (Amoxicillin Trihydrate)",
	"Arnica",
	"Isopropyl Alcohol",
	"Menthol",
	"Phenylephrine Hydrochloride",
	"Flunixin (Flunixin Meglumine)",
	"Mitotane",
	"Arginine Hydrochloride",
	"Modified Ragweed Tyrosine Adsorbate",
	"Calcitriol",
	"Hydroxyurea",
	"Oxazepam",
	"Alkyl Dimethyl Ethylbenzyl Ammonium Chloride",
	"Patent Blue Sodium",
	"Pramoxine Hydrochloride",
	"Oxycodone Hydrochloride",
	"Rubella Virus Vaccine Live Attenuated (Wistar Ra27/3 Strain)",
	"Lanolin",
	"Povidone-Iodine",
	"Trimethoprim",
	"Tetracosactide (Tetracosactide Zinc Hydroxide)",
	"Pheniramine Maleate",
	"Cresol",
	"Dimethyl Sulfoxide",
	"Urea",
	"Nonyl Phenoxypoly Ethoxy Ethanol-Iodine",
	"Diphenhydramine Hydrochloride",
	"Fluorescein (Fluorescein Sodium)",
	"P-Tert-Pentylphenol",
	"Glycine",
	"Vitamin B12",
	"Carbachol",
	"Calcium D-Pantothenate",
	"Cephalexin (Cephalexin Monohydrate)",
	"Nitrazepam",
	"Minoxidil",
	"Salicylic Acid",
	"Diclofenac Sodium",
	"Tetanus Toxoid Adsorbed",
	"Iodine (Nonyl Phenoxypolyethoxyethanol-Iodine Complex)",
	"Cromolyn Sodium",
	"Tylosin (Tylosin Phosphate)",
	"Indomethacin",
	"Oxytetracycline (Oxytetracycline Hydrochloride)",
	"Oil Of Camphor",
	"Sodium Dichloroisocyanurate",
	"Tretinoin",
	"Pizotifen (Pizotifen Malate)",
	"Aminophylline",
	"Trazodone Hydrochloride",
	"Propranolol Hydrochloride",
	"Guaifenesin",
	"Allopurinol",
	"Chlordiazepoxide Hydrochloride",
	"Phenelzine (Phenelzine Sulfate)",
	"Phenazopyridine Hydrochloride",
	"Zinc Sulfate",
	"Cetrimonium Bromide",
	"Ammonium Chloride",
	"Alprazolam",
	"Betamethasone (Betamethasone Valerate)",
	"Thymol",
	"Tobramycin",
	"Dextromethorphan Hydrobromide",
	"Sulfamethoxazole",
	"Buckthorn",
	"Flurazepam Hydrochloride",
	"Isosorbide Dinitrate",
	"Acetaminophen",
	"Mebendazole",
	"Dexamethasone Acetate",
	"Alprostadil",
	"Didecyl Dimethyl Ammonium Chloride",
	"Macrogol",
	"Acetazolamide",
	"Trihexyphenidyl Hydrochloride",
	"Metronidazole",
	"Glutathione Disulfide",
	"Nabilone",
	"Acyclovir",
	"Naproxen",
	"Metoprolol Tartrate",
	"Gonadorelin (Gonadorelin Hydrochloride)",
	"Neomycin Sulfate",
	"Polyvinyl Alcohol",
	"Menadione",
	"Isotretinoin",
	"Oxytetracycline Hydrochloride",
	"Cimetidine",
	"Nitrogen",
	"Pyrantel Tartrate",
	"Calcium Acetate",
	"Insulin Semi Synthetic Human",
	"Insulin Nph Human Dna Origin",
	"Promethazine Hydrochloride",
	"Tobramycin (Tobramycin Sulfate)",
	"Ibuprofen",
	"Fluocinonide",
	"Bronopol",
	"Dexamethasone Sodium Phosphate",
	"Pyridoxine Hydrochloride",
	"Menadione Sodium Bisulfite",
	"Colistin (Colistimethate Sodium)",
	"Histamine Phosphate",
	"Oxytetracycline",
	"Sodium Iodide",
	"Ivermectin",
	"Neatsfoot Oil",
	"Dodicin Hydrochloride",
	"D-Pantothenic Acid (Calcium D-Pantothenate, Riboflavin-5-Phosphate)",
	"Temazepam",
	"Fusidic Acid",
	"Fusidate Sodium",
	"Valproic Acid (Divalproex Sodium)",
	"Iodine (Nonyl Phenoxypoly Ethoxy Ethanol-Iodine)",
	"Oxygen",
	"Air",
	"Nitrous Oxide",
	"Carbon Dioxide",
	"Helium",
	"Amprolium",
	"Isoniazid",
	"Sulfasalazine",
	"Nicarbazin",
	"Bromine-Phenol-Benzethonium Chloride Complex",
	"Eucalyptol",
	"Cyclosporine",
	"Nonyl Phenoxy Polyoxyethylene Ethanol-Iodine Complex",
	"Cetylpyridinium Chloride",
	"Haloperidol",
	"Sulfaquinoxaline",
	"Copper Naphthenate",
	"Vitamin D",
	"Iron (Iron Dextran Complex)",
	"Cobalt Sulfate",
	"Hydromorphone Hydrochloride",
	"Etoposide",
	"Pyrazinamide",
	"Lorazepam",
	"Theophylline",
	"Morphine Hydrochloride",
	"Potassium Acetate",
	"Pollen And Non Pollen",
	"Diazoxide",
	"Charcoal Activated",
	"Sodium Acetate Trihydrate",
	"Urea Hydrogen Peroxide",
	"Penicillin V Potassium",
	"Iodine (Nonyl Phenoxy Polyoxyethylene Ethanol-Iodine Complex)",
	"Chlortetracycline (Chlortetracycline Hydrochloride)",
	"Penicillin G (Penicillin G Procaine)",
	"Dexamethasone Phosphate (Dexamethasone Sodium Phosphate)",
	"Sodium Sulfate",
	"Altrenogest",
	"Erythromycin",
	"Piroxicam",
	"Dipyridamole",
	"Clopidol",
	"Dioctyl Dimethyl Ammonium Chloride",
	"Diethylstilbestrol",
	"Sulfadoxine",
	"Fenbendazole",
	"Octyl Decyl Dimethyl Ammonium Chloride",
	"Vitamin D3",
	"Crotamiton",
	"Colestipol Hydrochloride",
	"Tryptophan",
	"Alfacalcidol",
	"Leuprolide Acetate",
	"Cyproterone Acetate",
	"Ranitidine (Ranitidine Hydrochloride)",
	"Tetracaine Hydrochloride",
	"Doxycycline (Doxycycline Hyclate)",
	"Estrone",
	"Heparin Sodium",
	"Cilastatin (Cilastatin Sodium)",
	"Benztropine Mesylate",
	"Trimipramine (Trimipramine Maleate)",
	"Enalapril Sodium",
	"Piperazine (Piperazine Adipate)",
	"Potassium Phosphate Monobasic",
	"Meperidine Hydrochloride",
	"Somatropin",
	"Dembrexine (Dembrexine Hydrochloride)",
	"Trifluridine",
	"Fluorometholone Acetate",
	"Sodium Tetradecyl Sulfate",
	"Nifedipine",
	"Nitroscanate",
	"Linear Dodecyl Benzene Sulfonic Acid",
	"Propafenone Hydrochloride",
	"Clenbuterol Hydrochloride",
	"Triamcinolone Acetonide",
	"Timolol Maleate",
	"Nizatidine",
	"Sodium Polystyrene Sulfonate",
	"Permethrin",
	"Nystatin",
	"Sodium Hypochlorite",
	"Diltiazem Hydrochloride",
	"Atenolol",
	"Nadolol",
	"Sulindac",
	"Naproxen Sodium",
	"Dexpanthenol",
	"Verapamil Hydrochloride",
	"Melatonin",
	"Cantharidin",
	"Erythromycin (Erythromycin Lactobionate)",
	"Gramicidin",
	"Azaperone",
	"Lipase",
	"Chloramphenicol (Chloramphenicol Palmitate)",
	"Thiamine Hydrochloride",
	"Epinephrine Hydrochloride",
	"Copper Gluconate",
	"Triazolam",
	"Petrolatum",
	"Vancomycin (Vancomycin Hydrochloride)",
	"Fluoxetine (Fluoxetine Hydrochloride)",
	"Insulin Isophane (Nph)",
	"Dinitolmide",
	"White Petrolatum",
	"Omeprazole",
	"Chlorhexidine Gluconate",
	"Sorbitol",
	"Octreotide (Octreotide Acetate)",
	"Prochlorperazine",
	"Clotrimazole",
	"Ascorbic Acid (Sodium Ascorbate)",
	"Vitamin K1",
	"Lincomycin (Lincomycin Hydrochloride)",
	"Melengestrol Acetate",
	"Polymyxin B (Polymyxin B Sulfate)",
	"Spectinomycin (Spectinomycin Sulfate)",
	"Ketoprofen",
	"Magnesium Chloride",
	"Dimethicone",
	"Isoflupredone Acetate",
	"Folic Acid (Sodium Folate)",
	"Ceftiofur (Ceftiofur Sodium)",
	"Dinoprost (Dinoprost Tromethamine)",
	"Amiloride Hydrochloride",
	"Sodium Citrate",
	"Potassium Phosphate Dibasic",
	"Cefixime",
	"Loratadine",
	"Apramycin (Apramycin Sulfate)",
	"Pyridostigmine Bromide",
	"Tamoxifen (Tamoxifen Citrate)",
	"Terbutaline Sulfate",
	"Budesonide",
	"Butorphanol (Butorphanol Tartrate)",
	"Chorionic Gonadotropin",
	"Gonadotrophin Serum (Pmsg)",
	"Oxyquinoline",
	"Hydrocortisone Sodium Succinate",
	"Prazosin (Prazosin Hydrochloride)",
	"Ketotifen (Ketotifen Fumarate)",
	"Salinomycin Sodium",
	"Tilmicosin",
	"Lactic Acid",
	"Clorazepate Dipotassium",
	"Captopril",
	"Gliclazide",
	"Simvastatin",
	"Fluconazole",
	"Xylazine (Xylazine Hydrochloride)",
	"Hydralazine Hydrochloride",
	"Ephedrine Sulfate",
	"Carboxymethylcellulose Sodium",
	"Mometasone Furoate",
	"Belladonna",
	"Sodium Phosphate Dibasic",
	"Cyclopentamine Hydrochloride",
	"Zidovudine",
	"Hexylresorcinol",
	"Ioversol",
	"Leucine",
	"Tiamulin Fumarate",
	"Ceftazidime",
	"Citric Acid",
	"Clozapine",
	"Follicle Stimulating Hormone (Fsh)",
	"Flurbiprofen",
	"Virginiamycin",
	"Poloxalene",
	"Norepinephrine (Norepinephrine Bitartrate)",
	"Isoproterenol Hydrochloride",
	"Enilconazole",
	"Glyburide",
	"Fluvoxamine Maleate",
	"Benzoyl Peroxide",
	"Gleptoferron (Iron Dextran Complex)",
	"Xylometazoline Hydrochloride",
	"Pseudoephedrine Sulfate",
	"Yohimbine Hydrochloride",
	"Podophyllotoxin",
	"Tiamulin (Tiamulin Hydrogen Fumarate)",
	"Amylase",
	"Clorophene",
	"Ampicillin (Ampicillin Sodium)",
	"Quinapril (Quinapril Hydrochloride)",
	"Trimeprazine (Trimeprazine Tartrate)",
	"Periciazine",
	"Zopiclone",
	"Felodipine",
	"Detomidine Hydrochloride",
	"Filgrastim",
	"Pseudoephedrine Hydrochloride",
	"Ethopropazine (Ethopropazine Hydrochloride)",
	"Nicotinamide",
	"Insulin Isophane Human Biosynthetic",
	"Insulin Injection Human Biosynthetic",
	"Spiramycin",
	"Chloroxylenol",
	"Enalaprilat",
	"Sertraline (Sertraline Hydrochloride)",
	"Lactulose",
	"Bethanechol Chloride",
	"Glutaral",
	"Clarithromycin",
	"Calcitonin (Salmon Synthetic)",
	"Epsiprantel",
	"Phenylephrine (Phenylephrine Hydrochloride)",
	"Dextrose (Dextrose Monohydrate)",
	"Calcium Borogluconate",
	"Amlodipine (Amlodipine Besylate)",
	"Ciprofloxacin (Ciprofloxacin Hydrochloride)",
	"Vitamin E (Dl-Alpha Tocopheryl Acetate)",
	"Apraclonidine (Apraclonidine Hydrochloride)",
	"Asparaginase",
	"Sodium Hypophosphite",
	"Albendazole",
	"Ketorolac Tromethamine",
	"Metolazone",
	"Tetanus Protein",
	"Methotrimeprazine (Methotrimeprazine Hydrochloride)",
	"Dextran 70",
	"Domperidone (Domperidone Maleate)",
	"Daunorubicin (Daunorubicin Hydrochloride)",
	"Moclobemide",
	"Methocarbamol",
	"Calcipotriol",
	"Finasteride",
	"Gadopentetate Dimeglumine",
	"Zinc (Zinc Sulfate)",
	"Clobetasol Propionate",
	"Amantadine Hydrochloride",
	"Onabotulinumtoxina",
	"Manganese (Manganese Sulfate)",
	"Chromium (Chromic Chloride)",
	"Deferoxamine Mesylate",
	"Salbutamol (Salbutamol Sulfate)",
	"Selenium (Selenious Acid)",
	"Copper (Cupric Sulfate)",
	"Lodoxamide (Lodoxamide Tromethamine)",
	"Iodide (Sodium Iodide)",
	"Trimethoprim (Trimethoprim Sulfate)",
	"Typhoid Vaccine (Salmonella Typhi Ty21a)",
	"Misoprostol",
	"Famotidine",
	"Peracetic Acid",
	"Hydrocotyle",
	"Edetate Sodium",
	"Nalbuphine Hydrochloride",
	"Diclofenac Potassium",
	"Metomidate Hydrochloride",
	"Cilazapril (Cilazapril Monohydrate)",
	"Potassium Hydroxide",
	"Sulfur",
	"Ephedrine Hydrochloride",
	"Desmopressin Acetate",
	"Fluocinolone Acetonide",
	"Clofedanol Hydrochloride",
	"Halobetasol Propionate",
	"Benzyl Di-Hydroxyethyl-Cocoalkyl-Ammonium Chl",
	"Terbinafine (Terbinafine Hydrochloride)",
	"Paroxetine (Paroxetine Hydrochloride)",
	"Dantrolene Sodium",
	"Novobiocin (Novobiocin Sodium)",
	"Enoxaparin Sodium",
	"L-Arginine",
	"Pentosan Polysulfate Sodium",
	"Neomycin (Neomycin Sulfate)",
	"Lidocaine (Lidocaine Hydrochloride)",
	"Penicillin G Procaine",
	"Penicillin G Benzathine",
	"Beractant",
	"Bumetanide",
	"Cholestyramine Resin",
	"Desogestrel",
	"Enalapril Maleate",
	"Gonadorelin Acetate",
	"Propofol",
	"Sucralfate",
	"Itraconazole",
	"Terbinafine Hydrochloride",
	"Loperamide Hydrochloride",
	"Glycopyrrolate",
	"Apis Mellifera Venom Protein Extract",
	"Isoflurane",
	"Ivermectin B1a",
	"Clonidine Hydrochloride",
	"Hydroxychloroquine Sulfate",
	"Danazol",
	"Clavulanic Acid (Potassium Clavulanate)",
	"Clavulanic Acid (Clavulanate Potassium)",
	"Pinaverium Bromide",
	"Dextroamphetamine Sulfate",
	"Tranylcypromine (Tranylcypromine Sulfate)",
	"Lidocaine (Lidocaine Hydrochloride Monohydrate)",
	"Alcohol Denatured",
	"Dornase Alfa",
	"Vigabatrin",
	"Baclofen",
	"Betaxolol (Betaxolol Hydrochloride)",
	"Conjugated Estrogens",
	"Lufenuron",
	"Digoxin",
	"Doxylamine Succinate",
	"L-Threonine",
	"Romifidine Hydrochloride",
	"Auranofin",
	"Liothyronine (Liothyronine Sodium)",
	"Cyclobenzaprine Hydrochloride",
	"Minocycline (Minocycline Hydrochloride)",
	"Gabapentin",
	"Bambermycin",
	"Hydrogen Peroxide",
	"Nonyl Phenoxypolyethoxyethanol-Iodine Complex",
	"Bupivacaine Hydrochloride",
	"Acitretin",
	"Iopromide",
	"Bromocriptine (Bromocriptine Mesylate)",
	"Goserelin (Goserelin Acetate)",
	"Iodine (Sodium Iodide)",
	"Vitamin B12 (Vitamin B12)",
	"Insulin Zinc Pork",
	"Articaine Hydrochloride",
	"Orphenadrine Citrate",
	"Dapsone",
	"Miconazole Nitrate",
	"Lisinopril",
	"Collagenase",
	"Paromomycin (Paromomycin Sulfate)",
	"Prilocaine",
	"Isosorbide-5-Mononitrate",
	"Mesalazine",
	"Perindopril Erbumine",
	"Estradiol",
	"Haloperidol (Haloperidol Decanoate)",
	"Sodium Linear Alkylate Sulfonate",
	"Ipratropium Bromide",
	"Bezafibrate",
	"Chlortetracycline Hydrochloride",
	"Metformin Hydrochloride",
	"Choline Bitartrate",
	"Lamotrigine",
	"Calcium Polystyrene Sulfonate",
	"Gemfibrozil",
	"Sodium Ioxitalamate",
	"Vitamin A (Vitamin A Acetate)",
	"Acebutolol (Acebutolol Hydrochloride)",
	"Carboplatin",
	"Olsalazine Sodium",
	"Naloxone Hydrochloride",
	"Indapamide",
	"Tranexamic Acid",
	"Rifabutin",
	"Formaldehyde",
	"Leucovorin (Leucovorin Calcium)",
	"Pentazocine (Pentazocine Hydrochloride)",
	"Dalteparin Sodium",
	"Milbemycin Oxime",
	"Aldesleukin",
	"Primaquine Phosphate",
	"Oxybutynin Chloride",
	"Indocyanine Green",
	"Dexrazoxane",
	"Ofloxacin",
	"Progesterone",
	"Lansoprazole",
	"Histidine",
	"Oxybenzone",
	"Penicillin G Potassium",
	"Piperonyl Butoxide",
	"Capsicum",
	"Soybean Oil",
	"Iodixanol",
	"D&C Red No. 28",
	"Halofuginone (Halofuginone Hydrobromide)",
	"Flupentixol Decanoate",
	"Flupentixol (Flupentixol Dihydrochloride)",
	"Pilocarpine Nitrate",
	"Fluorescein Sodium",
	"Prednisolone Sodium Phosphate",
	"Famciclovir",
	"Sotalol Hydrochloride",
	"Buffer Solution",
	"Danaparoid Sodium",
	"Beclomethasone Dipropionate",
	"Levocarnitine",
	"Calcium Gluconate",
	"Bromazepam",
	"Codeine (Codeine Monohydrate, Codeine Sulfate Trihydrate)",
	"Calcium Carbonate",
	"L-Isoleucine",
	"Losartan Potassium",
	"Cefoxitin (Cefoxitin Sodium)",
	"Tinzaparin Sodium",
	"Interferon Beta-1b",
	"Procainamide Hydrochloride",
	"Metoclopramide Hydrochloride",
	"Ethylene Oxide",
	"Adenosine",
	"Protamine Sulfate",
	"Dequalinium Chloride",
	"Fludrocortisone 21-Acetate",
	"Sevoflurane",
	"Cefazolin (Cefazolin Sodium)",
	"Mycophenolate Mofetil",
	"Ethylenediamine Dihydroiodide",
	"Ganciclovir (Ganciclovir Sodium)",
	"Levothyroxine Sodium",
	"L-Tyrosine",
	"Lamivudine",
	"Bicalutamide",
	"Acarbose",
	"Desoxycortone Pivalate",
	"Methotrexate (Methotrexate Sodium)",
	"Omeprazole (Omeprazole Magnesium)",
	"Tiaprofenic Acid",
	"Deslorelin (Deslorelin Acetate)",
	"Vincristine Sulfate",
	"Bacillus Calmette-Guerin (Bcg) Strain Tice",
	"Decoquinate",
	"Buspirone Hydrochloride",
	"Desipramine (Desipramine Hydrochloride)",
	"Megestrol Acetate",
	"Dorzolamide (Dorzolamide Hydrochloride)",
	"Oxytetracycline (Oxytetracycline Dihydrate)",
	"Spectinomycin (Spectinomycin Hydrochloride)",
	"Adapalene",
	"Norethindrone",
	"Levodopa",
	"Valacyclovir (Valacyclovir Hydrochloride)",
	"Hyaluronate Sodium",
	"Hepatitis A Vaccine, Inactivated",
	"Lysine (L-Lysine Hydrochloride)",
	"Salmonella Typhi Vi Capsular Polysaccharide Vaccine",
	"L-Proline",
	"Erythrosine",
	"Silicone",
	"Tolnaftate",
	"Labetalol Hydrochloride",
	"Potassium Peroxymonosulfate",
	"Acetylcholine Chloride",
	"Sodium Thiosulfate",
	"Vasopressin",
	"Sodium Acetate",
	"Ascorbic Acid",
	"Trolamine Salicylate",
	"Desonide",
	"Polyethoxy Polypropoxy Polyethoxy Ethanol - Iodine Complex",
	"Loxapine (Loxapine Hydrochloride)",
	"Ribavirin",
	"Hamamelis Virginiana",
	"Clobetasone Butyrate",
	"Cetrimide",
	"Penicillin G (Penicillin G Sodium)",
	"Esculin",
	"Dermatophagoides Farinae",
	"Normethadone Hydrochloride",
	"Disopyramide",
	"Benzethonium Chloride",
	"Diatrizoate Sodium",
	"Sincalide",
	"Pyrithione Zinc",
	"Myroxylon Balsamum",
	"Oxymetazoline Hydrochloride",
	"Octinoxate",
	"Tetrahydrozoline Hydrochloride",
	"Meradimate",
	"Bismuth Subsalicylate",
	"Pectin",
	"Methotrexate",
	"Erythromycin Thiocyanate",
	"Nafarelin (Nafarelin Acetate)",
	"Esmolol Hydrochloride",
	"Albumin (Human)",
	"Doxorubicin Hydrochloride",
	"Tetrabenazine",
	"Anti-Inhibitor Coagulant Complex",
	"Alfa 1-Proteinase Inhibitor (Human)",
	"Coagulation Factor Ix (Human)",
	"Bacitracin (Bacitracin Methylene Disalicylate)",
	"Dobutamine (Dobutamine Hydrochloride)",
	"Azithromycin",
	"Sumatriptan (Sumatriptan Succinate)",
	"Cefuroxime (Cefuroxime Axetil)",
	"Ondansetron (Ondansetron Hydrochloride Dihydrate)",
	"Naltrexone Hydrochloride",
	"Florfenicol",
	"Dermatophagoides Pteronyssinus",
	"Atovaquone",
	"Standardized Cat Hair Acetone Precipitated",
	"Honey Bee Venom Protein",
	"Yellow Hornet Venom Protein",
	"Wasp Venom Protein",
	"White Faced Hornet Venom Protein",
	"Yellow Jacket Venom Protein",
	"Lovastatin",
	"Benazepril Hydrochloride",
	"Ciclopirox Olamine",
	"Ramipril",
	"Nilutamide",
	"Desoximetasone",
	"Cetirizine Hydrochloride",
	"Quinagolide (Quinagolide Hydrochloride)",
	"Anastrozole",
	"Buserelin (Buserelin Acetate)",
	"Desflurane",
	"Prednicarbate",
	"Iopamidol",
	"Gadoteridol",
	"Olanzapine",
	"Cisplatin",
	"Cytarabine",
	"Bleomycin (Bleomycin Sulfate)",
	"Zeranol",
	"Cloprostenol (Cloprostenol Sodium)",
	"Tyrosine",
	"Sulfadiazine (Sulfadiazine Sodium)",
	"Inactivated Poliomyelitis Vaccine (V.C.O.) Type 3 Saukett",
	"Tricaine",
	"Enrofloxacin",
	"Praziquantel",
	"Febantel",
	"Methotrexate (Methotrexate Disodium)",
	"Gonadorelin Diacetate Tetrahydrate",
	"Iohexol",
	"Gadodiamide",
	"Cloxacillin (Cloxacillin Benzathine)",
	"Cephapirin (Cephapirin Benzathine)",
	"Cephapirin (Cephapirin Sodium)",
	"Amikacin (Amikacin Sulfate)",
	"Spectinomycin (Spectinomycin Dihydrochloride Pentahydrate)",
	"Tacrolimus",
	"Ketoconazole",
	"Vinblastine Sulfate",
	"Pentamidine Isetionate",
	"Prochlorperazine (Prochlorperazine Maleate)",
	"Rabies Vaccine Inactivated (Human Diploid-Cell Culture)",
	"Potassium Citrate",
	"Ropivacaine Hydrochloride",
	"Mefenamic Acid",
	"Pantoprazole (Pantoprazole Sodium)",
	"Norfloxacin",
	"Semduramicin (Semduramicin Sodium)",
	"Raltitrexed (Raltitrexed Disodium)",
	"Valproic Acid",
	"Insulin Lispro",
	"Benzydamine Hydrochloride",
	"Dipyrone Monohydrate",
	"Pentoxifylline",
	"Calcium Gluconate Monohydrate",
	"Mexiletine Hydrochloride",
	"Zuclopenthixol (Zuclopenthixol Hydrochloride)",
	"Zuclopenthixol Acetate",
	"Zuclopenthixol Decanoate",
	"Carboprost (Carboprost Tromethamine)",
	"Sumatriptan (Sumatriptan Hemisulfate)",
	"Mitomycin",
	"Tetracaine (Tetracaine Hydrochloride)",
	"Immunoglobulin (Human)",
	"Neostigmine Methylsulfate",
	"Prednisolone (Prednisolone Sodium Phosphate)",
	"Selegiline Hydrochloride",
	"Tetanus Immunoglobulin (Human)",
	"Kaolin",
	"Atorvastatin (Atorvastatin Calcium)",
	"Hepatitis B Immunoglobulin (Human)",
	"Tazarotene",
	"Terazosin (Terazosin Hydrochloride)",
	"Loxapine (Loxapine Succinate)",
	"Epoprostenol (Epoprostenol Sodium)",
	"Formoterol Fumarate",
	"Topiramate",
	"Dichlorophene",
	"Fosphenytoin Sodium",
	"Doramectin",
	"Salmeterol (Salmeterol Xinafoate)",
	"Monensin (Monensin Sodium)",
	"Fumagillin (Fumagillin Dicyclohexylamine)",
	"Letrozole",
	"Trandolapril",
	"Fexofenadine Hydrochloride",
	"Latanoprost",
	"Estradiol (Estradiol Hemihydrate)",
	"Epoetin Alfa",
	"Carbetocin",
	"Moxidectin",
	"Cytomegalovirus Immunoglobulin (Human)",
	"Donepezil Hydrochloride",
	"Avobenzone",
	"Olopatadine (Olopatadine Hydrochloride)",
	"Lymphocyte Immunoglobulin Anti-Thymocyte Globulin (Equine)",
	"Cefadroxil (Cefadroxil Monohydrate)",
	"Anagrelide (Anagrelide Hydrochloride)",
	"L-Ornithine Dihydrochloride",
	"Brimonidine Tartrate",
	"Nadroparin Calcium",
	"Acyclovir (Acyclovir Sodium)",
	"Risperidone (Risperidone Tartrate)",
	"Quetiapine (Quetiapine Fumarate)",
	"Bacitracin Zinc",
	"Pramipexole Dihydrochloride Monohydrate",
	"Titanium Dioxide",
	"Bacitracin (Bacitracin Zinc)",
	"Formoterol Fumarate Dihydrate",
	"Eprinomectin",
	"Fluticasone Propionate",
	"Venlafaxine (Venlafaxine Hydrochloride)",
	"Interferon Beta-1a",
	"Rabies Immunoglobulin (Human)",
	"Vitamin D2",
	"Ciprofloxacin",
	"Dodecyl Dimethyl Benzyl Ammonium Chloride",
	"Cephapirin Benzathine",
	"Orbifloxacin",
	"Meloxicam",
	"Atipamezole Hydrochloride",
	"Antithrombin Iii (Human)",
	"Naratriptan (Naratriptan Hydrochloride)",
	"Irbesartan",
	"Proguanil Hydrochloride",
	"Montelukast (Montelukast Sodium)",
	"Clobazam",
	"Methotrimeprazine (Methotrimeprazine Maleate)",
	"Bupropion Hydrochloride",
	"Capecitabine",
	"Standardized Kentucky Blue/June Grass Pollen",
	"Standardized Orchard Grass Pollen",
	"Standardized Redtop Grass Pollen",
	"Sweet Vernal Grass",
	"Standardized Timothy Grass Pollen",
	"Standardized Perennial Rye Grass Pollen",
	"Betaine",
	"Flutamide",
	"Hydrocortisone Acetate",
	"Nelfinavir (Nelfinavir Mesylate)",
	"Iodine",
	"Zinc Oxide",
	"Pine Tar",
	"Nabumetone",
	"Zolmitriptan",
	"Interferon Alfa-2b",
	"Clopidogrel (Clopidogrel Bisulfate)",
	"Sodium Borate",
	"Brinzolamide",
	"Vitamin A Propionate",
	"Ursodiol",
	"Raloxifene Hydrochloride",
	"Tolterodine Tartrate",
	"Candesartan Cilexetil",
	"Miconazole (Miconazole Nitrate)",
	"Haemophilus Influenzae Type B-Prp And Tetanus Toxoid Conjugate (Prp-T)",
	"Ondansetron",
	"Cat (Felis Domesticus) Pelt And Cat Dander",
	"Imiquimod",
	"Citalopram (Citalopram Hydrobromide)",
	"Testosterone",
	"Methacholine Chloride",
	"Modafinil",
	"Sildenafil (Sildenafil Citrate)",
	"Amiodarone Hydrochloride",
	"Fenofibrate",
	"Efavirenz",
	"Repaglinide",
	"Celecoxib",
	"Triptorelin (Triptorelin Pamoate)",
	"Tilmicosin (Tilmicosin Phosphate)",
	"Fimbriae Types 2 And 3 (Fim)",
	"Midazolam",
	"Insulin Lispro Protamine Suspension",
	"Orlistat",
	"Fosfomycin (Fosfomycin Tromethamine)",
	"Anethole Trithione",
	"Mycophenolate Mofetil (Mycophenolate Mofetil Hydrochloride)",
	"Eptifibatide",
	"Abacavir (Abacavir Sulfate)",
	"Eprosartan (Eprosartan Mesylate)",
	"Fentanyl (Fentanyl Citrate)",
	"Rizatriptan (Rizatriptan Benzoate)",
	"Doxazosin (Doxazosin Mesylate)",
	"Trastuzumab",
	"Tirofiban (Tirofiban Hydrochloride)",
	"Inosine Pranobex",
	"Telmisartan",
	"Cefadroxil",
	"Icodextrin",
	"Zanamivir",
	"Gadobutrol",
	"Temozolomide",
	"Octisalate",
	"Terephthalylidene Dicamphor Sulfonic Acid",
	"Ifosfamide",
	"Sulfadiazine",
	"Methadone Hydrochloride",
	"Mesna",
	"Marbofloxacin",
	"Dacarbazine",
	"Oseltamivir (Oseltamivir Phosphate)",
	"Poractant Alfa",
	"Cefuroxime (Cefuroxime Sodium)",
	"Imiglucerase",
	"Cyclophosphamide",
	"Leflunomide",
	"Epinephrine Bitartrate",
	"Rituximab",
	"Selamectin",
	"Oxcarbazepine",
	"Melarsomine Dihydrochloride",
	"Rivastigmine (Rivastigmine Hydrogen Tartrate)",
	"Verteporfin",
	"Tiamulin (Tiamulin Fumarate)",
	"Ibutilide Fumarate",
	"Cabergoline",
	"Thymol (Thyme Oil)",
	"Butorphanol Tartrate",
	"Framycetin Sulfate",
	"Padimate O",
	"Standardized Sweet Vernal Grass Pollen",
	"Standardized Meadow Fescue Grass Pollen",
	"Warfarin Sodium",
	"Exemestane",
	"Allergen Extract - Alum Precipitated",
	"Riluzole",
	"Scopolamine Hydrobromide",
	"Basiliximab",
	"Pamabrom",
	"Ormetoprim",
	"Robenidine Hydrochloride",
	"Fomepizole",
	"Hydrocortisone Valerate",
	"Levonorgestrel",
	"Fimbriae",
	"Perflutren",
	"Sirolimus",
	"Glucagon (Recombinant Dna Origin)",
	"Octocrylene",
	"Iron (Sodium Ferric Gluconate Complex In Sucrose Injection)",
	"Nitenpyram",
	"Pravastatin Sodium",
	"Ritonavir",
	"Streptomycin (Streptomycin Sulfate)",
	"Hepatitis B Surface Antigen (Recombinant)",
	"Linezolid",
	"Iron (Iron Sucrose)",
	"Phentolamine Mesylate",
	"Entacapone",
	"Rabeprazole Sodium",
	"Argatroban",
	"Eflornithine Hydrochloride",
	"Betahistine Hydrochloride",
	"Mirtazapine",
	"Desloratadine",
	"Aminolevulinic Acid Hydrochloride",
	"Follitropin Beta",
	"Brompheniramine Maleate",
	"Infliximab",
	"Hydrocodone Bitartrate",
	"Sufentanil (Sufentanil Citrate)",
	"Caspofungin (Caspofungin Acetate)",
	"Sevelamer Hydrochloride",
	"Insulin Aspart",
	"Mefloquine (Mefloquine Hydrochloride)",
	"Paclitaxel",
	"Esomeprazole (Esomeprazole Magnesium Trihydrate)",
	"Pamidronate Disodium",
	"Milrinone (Milrinone Lactate)",
	"Valsartan",
	"Tenecteplase",
	"Azathioprine (Azathioprine Sodium)",
	"Bosentan (Bosentan Monohydrate)",
	"Tetanus Toxoid",
	"Carbidopa",
	"Ascorbic Acid (Ascorbic Acid)",
	"Alendronic Acid (Alendronate Sodium)",
	"Pimozide",
	"Surfactant-Associated Proteins Sp-B And Sp-C",
	"Fondaparinux Sodium",
	"Alfuzosin Hydrochloride",
	"Glatiramer Acetate",
	"Ganirelix (Ganirelix Acetate)",
	"Trimebutine Maleate",
	"Tylosin Tartrate",
	"Cyproheptadine Hydrochloride",
	"Docosanol",
	"Insulin Glargine",
	"Valganciclovir (Valganciclovir Hydrochloride)",
	"Clodronate Disodium",
	"Alteplase",
	"Methazolamide",
	"Anakinra",
	"Carvedilol",
	"Iron (Gleptoferron)",
	"Thyrotropin Alfa",
	"Diclazuril",
	"Prednisolone (Prednisolone Acetate)",
	"Varicella-Zoster Virus Vaccine Live Attenuated (Oka/Merck Strain)",
	"Flunarizine (Flunarizine Hydrochloride)",
	"Zinc Acetate",
	"Fludarabine Phosphate",
	"Pine Oil",
	"Bivalirudin",
	"Treprostinil (Treprostinil Sodium)",
	"Carprofen",
	"O-Phenylphenol",
	"Amcinonide",
	"Docusate Calcium",
	"Tiotropium (Tiotropium Bromide Monohydrate)",
	"Anti-Thymocyte Globulin (Rabbit)",
	"Oxytetracycline Hydrochloride (Oxytetracycline Dihydrate)",
	"Risedronate Sodium (Risedronate Sodium Hemipentahydrate)",
	"Levetiracetam",
	"Phenylpropanolamine Hydrochloride",
	"Olanzapine (Olanzapine Tartrate)",
	"Tenofovir Disoproxil Fumarate",
	"Sennosides",
	"Rosuvastatin (Rosuvastatin Calcium)",
	"Vibrio Cholerae Ogawa 50 Classical Biotype, Heat Inactivated",
	"Pimecrolimus",
	"Ertapenem (Ertapenem Sodium)",
	"Bisoprolol Fumarate",
	"Ezetimibe",
	"Povidone",
	"Pertactin",
	"Chloral Hydrate",
	"Terconazole",
	"Enfuvirtide",
	"Allergenic Extracts Pollens",
	"Allergenic Extract Non-Pollen",
	"Cetrorelix (Cetrorelix Acetate)",
	"Fosinopril Sodium",
	"Dutasteride",
	"Adefovir Dipivoxil",
	"Ciprofloxacin (Ciprofloxacin, Ciprofloxacin Hydrochloride)",
	"Peginterferon Alfa-2a",
	"Tadalafil",
	"Follitropin Alfa",
	"Pimobendan",
	"Zoledronic Acid (Zoledronic Acid Monohydrate)",
	"Gadobenate Dimeglumine",
	"Rasburicase",
	"Paroxetine (Paroxetine Hydrochloride Acetone Solvate)",
	"Paroxetine (Paroxetine Hydrochloride, Isopropyl Solvate)",
	"Atazanavir (Atazanavir Sulfate)",
	"Fulvestrant",
	"Gefitinib",
	"Etidronate Disodium",
	"Mixed Salts Amphetamine",
	"Agalsidase Beta",
	"Agalsidase Alfa",
	"Flumazenil",
	"Pegfilgrastim",
	"Ponazuril",
	"Ceftriaxone (Ceftriaxone Sodium)",
	"Vardenafil (Vardenafil Hydrochloride)",
	"Miglustat",
	"Fluvastatin (Fluvastatin Sodium)",
	"Ciclopirox",
	"Hyprolose",
	"Risperidone",
	"Moxifloxacin (Moxifloxacin Hydrochloride)",
	"Iron (Ferric Hydroxide Dextran Complex)",
	"Vitamin D3 (Cholecalciferol)",
	"Imatinib (Imatinib Mesylate)",
	"Pemetrexed (Pemetrexed Disodium)",
	"Laronidase",
	"Teriparatide",
	"Oxybutynin",
	"Sodium Picosulfate",
	"Paraffin",
	"Eletriptan (Eletriptan Hydrobromide)",
	"Voriconazole",
	"Frovatriptan (Frovatriptan Succinate)",
	"Cinacalcet (Cinacalcet Hydrochloride)",
	"Gatifloxacin",
	"Vinorelbine (Vinorelbine Tartrate)",
	"Irinotecan Hydrochloride",
	"Ethacrynic Acid",
	"Adalimumab",
	"Tizanidine (Tizanidine Hydrochloride)",
	"Anagrelide (Anagrelide Hydrochloride Monohydrate)",
	"Omalizumab",
	"Memantine Hydrochloride",
	"Danofloxacin (Danofloxacin Mesylate)",
	"Von Willebrand Factor (Human)",
	"Antihemophilic Factor (Human)",
	"Fosamprenavir (Fosamprenavir Calcium)",
	"Choriogonadotropin Alfa",
	"Bortezomib (Bortezomib Mannitol Boronic Ester)",
	"Acetic Acid",
	"Atomoxetine (Atomoxetine Hydrochloride)",
	"Escitalopram (Escitalopram Oxalate)",
	"Calcium (Calcium Carbonate)",
	"Levomenthol",
	"Mycophenolic Acid (Mycophenolate Sodium)",
	"Pirlimycin (Pirlimycin Hydrochloride)",
	"Insulin Aspart Protamine",
	"Deracoxib",
	"Azithromycin (Azithromycin Dihydrate)",
	"Cannabidiol (Cannabis Sativa Extract)",
	"Pantoprazole (Pantoprazole Magnesium)",
	"Rabies Vaccine Inactivated (Purified Chick Embryo Cell Culture)",
	"Azithromycin (Azithromycin Monohydrate Hemiethanolate)",
	"Sodium Oxybate",
	"Pregabalin",
	"Erlotinib (Erlotinib Hydrochloride)",
	"Lutropin Alfa",
	"Glimepiride",
	"Sodium Phosphate (Tribasic)",
	"Human Plasma Proteins",
	"Tamsulosin Hydrochloride",
	"Azelaic Acid",
	"Nitric Oxide",
	"Bevacizumab",
	"Cetuximab",
	"Insulin Detemir",
	"Hydrochloric Acid",
	"Pegvisomant",
	"Ipratropium Bromide (Ipratropium Bromide Monohydrate)",
	"Darifenacin (Darifenacin Hydrobromide)",
	"Tipranavir",
	"Etanercept",
	"Emtricitabine",
	"Octanoic Acid",
	"Trospium Chloride",
	"Pyrilamine Maleate",
	"Flecainide Acetate",
	"Insulin Isophane Injection Pork",
	"Insulin Injection Pork",
	"Solifenacin Succinate",
	"Hydroxyethyl Starch 130/0.4",
	"Midodrine Hydrochloride",
	"Insulin Glulisine (Recombinant Dna Origin)",
	"Trypan Blue",
	"Isopropyl Myristate",
	"Meningococcal Polysaccharide-Diphtheria Toxoid Conjugate, Group W 135",
	"Mupirocin",
	"Sunitinib (Sunitinib Malate)",
	"Amoxicillin Trihydrate",
	"Abatacept",
	"Entecavir",
	"Fentanyl",
	"Menotropins",
	"Lanreotide (Lanreotide Acetate)",
	"Antihemophilic Factor (Recombinant)",
	"Sorafenib (Sorafenib Tosylate)",
	"Human-Bovine Rotavirus Reassortant Type P1(8)",
	"Rasagiline (Rasagiline Mesylate)",
	"Levofloxacin (Levofloxacin Hemihydrate)",
	"Alglucosidase Alfa",
	"Desmopressin (Desmopressin Acetate)",
	"Tigecycline",
	"Tulathromycin",
	"Pantoprazole (Pantoprazole Sodium Sesquihydrate)",
	"Ciclesonide",
	"Drometrizole Trisiloxane",
	"Mitoxantrone (Mitoxantrone Hydrochloride)",
	"Dimethylbenzyl Ammonium Chloride",
	"Natalizumab",
	"Tramadol Hydrochloride",
	"Lanthanum (Lanthanum Carbonate Hydrate)",
	"Deferasirox",
	"Sulfur Hexafluoride",
	"Lisinopril (Lisinopril Dihydrate)",
	"Alemtuzumab",
	"Polyhexanide",
	"Varenicline (Varenicline Tartrate)",
	"Homosalate",
	"Enalapril Sodium (Enalapril Maleate)",
	"Dasatinib (Dasatinib Monohydrate)",
	"Acamprosate Calcium",
	"Posaconazole",
	"Cefprozil (Cefprozil Monohydrate)",
	"Coagulation Factor Ix (Recombinant)",
	"Micafungin Sodium",
	"Protein S",
	"Ractopamine Hydrochloride",
	"Atorvastatin (Atorvastatin Calcium Propylene Glycol Solvate)",
	"Cefovecin (Cefovecin Sodium)",
	"Naloxone (Naloxone Hydrochloride Dihydrate)",
	"Idursulfase",
	"Ranibizumab",
	"Pioglitazone (Pioglitazone Hydrochloride)",
	"Ceftiofur (Ceftiofur Hydrochloride)",
	"Risedronate Sodium (Risedronate Sodium Monohydrate)",
	"Fluticasone Furoate",
	"Ziprasidone (Ziprasidone Hydrochloride Monohydrate)",
	"Aprepitant",
	"Iodine (Polyalkylene Glycol Ether Iodophor - Complex)",
	"Estradiol Cypionate",
	"Maropitant (Maropitant Citrate)",
	"Tazobactam (Tazobactam Sodium)",
	"Maraviroc",
	"Nelarabine",
	"Firocoxib",
	"Paliperidone",
	"Duloxetine (Duloxetine Hydrochloride)",
	"Raltegravir (Raltegravir Potassium)",
	"Aliskiren (Aliskiren Fumarate)",
	"Cefprozil",
	"Anti-D (Rh) Immunoglobulin (Human)",
	"Rivastigmine",
	"Sodium Chlorite",
	"Sitagliptin (Sitagliptin Phosphate Monohydrate)",
	"Phenobarbital Sodium",
	"Temsirolimus",
	"Desmopressin Acetate (Desmopressin Acetate Trihydrate)",
	"Lenalidomide",
	"Ondansetron (Ondansetron Hydrochloride)",
	"Ceftiofur (Ceftiofur Crystalline Free Acid)",
	"Ensulizole",
	"Etravirine",
	"Ambrisentan",
	"Methylnaltrexone Bromide",
	"Panitumumab",
	"Granisetron (Granisetron Hydrochloride)",
	"Nepafenac",
	"Moroctocog Alfa",
	"Benzoic Acid",
	"Dabigatran Etexilate (Dabigatran Etexilate Mesilate)",
	"Inactivated Poliovirus Type Iii",
	"Ropinirole (Ropinirole Hydrochloride)",
	"Levofloxacin",
	"Nilotinib (Nilotinib Hydrochloride Monohydrate)",
	"Gonadorelin (Gonadorelin Acetate)",
	"Emodepside",
	"Galantamine (Galantamine Hydrobromide)",
	"Rivaroxaban",
	"Polyethylene Glycol 3350",
	"Travoprost",
	"Rocuronium Bromide",
	"Nevirapine",
	"Olmesartan Medoxomil",
	"Cladribine",
	"Pneumococcal Polysaccharide Serotype 23f Conjugated To Protein D Carrier Protein",
	"Ustekinumab",
	"Loteprednol Etabonate",
	"Desvenlafaxine (Desvenlafaxine Succinate)",
	"Lasalocid Sodium",
	"Trilostane",
	"Eculizumab",
	"Donepezil Hydrochloride (Donepezil Hydrochloride Monohydrate)",
	"Aripiprazole",
	"Testosterone Undecanoate",
	"Romiplostim",
	"Lisdexamfetamine Dimesylate",
	"Eplerenone",
	"Methyl Aminolevulinate (Methyl Aminolevulinate Hydrochloride)",
	"Darunavir (Darunavir Ethanolate)",
	"Incobotulinumtoxina",
	"Alfaxalone",
	"Epirubicin Hydrochloride",
	"Gemcitabine (Gemcitabine Hydrochloride)",
	"Adenine",
	"Golimumab",
	"Bimatoprost",
	"Nimodipine",
	"Lapatinib (Lapatinib Ditosylate Monohydrate)",
	"Gatifloxacin (Gatifloxacin Hemihydrate)",
	"Vorinostat",
	"Tetrakis [Cu(Mibi)4]Bf4",
	"Fludeoxyglucose 18f",
	"Gallium Citrate Ga 67",
	"Bicisate Dihydrochloride",
	"Thallium Chloride(Ti 201)",
	"Emamectin Benzoate",
	"Pyrantel Pamoate",
	"Technetium Tc 99m",
	"Ibritumomab Tiuxetan",
	"Tetrofosmin",
	"Indium Oxine",
	"Exametazime",
	"Tauroselcholic Acid (75se)",
	"Pentetate Indium Disodium In 111",
	"Medronic Acid",
	"Pentetreotide",
	"Betiatide",
	"Technetium Tc 99m Red Blood Cells",
	"Albumin",
	"Indium In 111 Chloride",
	"Pentetic Acid",
	"Sodium Iodide 131 I",
	"Aztreonam",
	"Clofarabine",
	"Anidulafungin",
	"Telavancin (Telavancin Hydrochloride)",
	"Dronedarone (Dronedarone Hydrochloride)",
	"Certolizumab Pegol",
	"Azithromycin (Azithromycin Monohydrate)",
	"Antipyrine",
	"Spinosad",
	"Inact.Japanese Encephal Virus(Attenuat. Strain Sa14-14-2 Produced In Vero Cells)",
	"Saxagliptin (Saxagliptin Hydrochloride)",
	"Glucagon (Recombinant Dna Origin) (Glucagon Hydrochloride)",
	"Dexmedetomidine Hydrochloride",
	"Corynebacterium Diphtheriae Crm-197 Protein",
	"Sodium Hydroxide",
	"White Cedar Oil",
	"Azacitidine",
	"Besifloxacin (Besifloxacin Hydrochloride)",
	"Degarelix (Degarelix Acetate)",
	"Medetomidine Hydrochloride",
	"Alitretinoin",
	"Toceranib (Toceranib Phosphate)",
	"Diclofenac Diethylamine",
	"Esomeprazole (Esomeprazole Magnesium)",
	"Dexmedetomidine (Dexmedetomidine Hydrochloride)",
	"Everolimus",
	"Gadoxetate Disodium",
	"Buprenorphine",
	"Calcium Glucoheptonate",
	"Recombinant Human Papillomavirus Type 18 L1 Protein",
	"Buprenorphine (Buprenorphine Hydrochloride)",
	"Denosumab",
	"Remifentanil (Remifentanil Hydrochloride)",
	"Haemagglutinin-Strain B",
	"Valacyclovir (Valacyclovir Hydrochloride Monohydrate)",
	"Gamithromycin",
	"Thrombin (Human)",
	"Tocilizumab",
	"Sapropterin Dihydrochloride",
	"Liraglutide",
	"Trabectedin",
	"Diphtheria Toxoid",
	"Pazopanib (Pazopanib Hydrochloride)",
	"Lysine (L-Lysine Acetate)",
	"C1 Esterase Inhibitor (Human)",
	"Dexamethasone (Dexamethasone Acetate)",
	"Paliperidone (Paliperidone Palmitate)",
	"Sevelamer Carbonate",
	"Dexlansoprazole",
	"Thalidomide",
	"Toltrazuril",
	"Sterile Water (Diluent)",
	"Velaglucerase Alfa",
	"Febuxostat",
	"Irinotecan Hydrochloride (Irinotecan Hydrochloride Trihydrate)",
	"Lacosamide",
	"Hypochlorous Acid",
	"Acetazolamide (Acetazolamide Sodium)",
	"Roflumilast",
	"Antimony Trisulfide",
	"Digoxin Immune Fab (Ovine)",
	"Silodosin",
	"Sodium Nitroprusside",
	"Exenatide",
	"Eltrombopag (Eltrombopag Olamine)",
	"Docetaxel",
	"Fosaprepitant (Fosaprepitant Dimeglumine)",
	"Fingolimod (Fingolimod Hydrochloride)",
	"Dicyclomine Hydrochloride",
	"Ticagrelor",
	"Cabazitaxel",
	"Gonadotropin-Releasing Factor Analog-Diphtheria Toxoid Conjugate",
	"Rufinamide",
	"Belimumab",
	"Zolpidem Tartrate",
	"Tolvaptan",
	"Rilpivirine (Rilpivirine Hydrochloride)",
	"Linagliptin",
	"Abiraterone Acetate",
	"Iodine (Hydriodic Acid - Iodine Complex)",
	"Tylvalosin (Tylvalosin Tartrate)",
	"Colesevelam Hydrochloride",
	"Rubidium Chloride Rb 82",
	"Robenacoxib",
	"Asenapine (Asenapine Maleate)",
	"Dienogest",
	"Hydroxocobalamin",
	"Amylmetacresol",
	"Doxycycline (Doxycycline Monohydrate)",
	"Hydrocortisone Aceponate",
	"Indacaterol (Indacaterol Maleate)",
	"Prucalopride (Prucalopride Succinate)",
	"Plerixafor",
	"Apixaban",
	"Sodium Citrate Dihydrate",
	"Eribulin Mesylate",
	"Silver Nitrate",
	"Tapentadol (Tapentadol Hydrochloride)",
	"Vandetanib",
	"Meropenem (Meropenem Trihydrate)",
	"Ipilimumab",
	"Topotecan (Topotecan Hydrochloride)",
	"Fampridine",
	"Fesoterodine Fumarate",
	"Vemurafenib",
	"Azilsartan Medoxomil (Azilsartan Medoxomil Potassium)",
	"Palonosetron (Palonosetron Hydrochloride)",
	"Grass Pollen Allergen Extract",
	"Iodine (Nonylphenoxypoly(Ethyleneoxy)Ethanol Iodine Complex)",
	"Naloxone Hydrochloride (Naloxone Hydrochloride Dihydrate)",
	"Dichlorobenzyl Alcohol",
	"Paroxetine (Paroxetine Hydrochloride Hemihydrate)",
	"Crizotinib",
	"Iobenguane 123 I",
	"Fidaxomicin",
	"Zinc Sulfate Monohydrate",
	"Levomefolate Calcium",
	"Tildipirosin",
	"Abobotulinumtoxina",
	"Lurasidone Hydrochloride",
	"Halofuginone (Halofuginone Lactate)",
	"Ruxolitinib (Ruxolitinib Phosphate)",
	"Triptorelin Acetate",
	"Axitinib",
	"Clorophene Sodium",
	"Catridecacog",
	"Darbepoetin Alfa",
	"Bendamustine Hydrochloride",
	"Fibrinogen (Human)",
	"Pirfenidone",
	"Glycopyrronium (Glycopyrronium Bromide)",
	"Fish Oil",
	"Cobicistat",
	"Ivacaftor",
	"Cefpodoxime (Cefpodoxime Proxetil)",
	"Tetracaine",
	"Almotriptan (Almotriptan Malate)",
	"Stiripentol",
	"Nebivolol (Nebivolol Hydrochloride)",
	"Polysorbate 80",
	"Piperacillin (Piperacillin Sodium)",
	"Brentuximab Vedotin",
	"Sodium Fluoride F 18",
	"Mirabegron",
	"Rosiglitazone (Rosiglitazone Maleate)",
	"Regorafenib",
	"Rotigotine",
	"Dimethyl Fumarate",
	"Perampanel",
	"Pertuzumab",
	"Insulin (Human)",
	"Methoxsalen",
	"Glycolic Acid",
	"Enzalutamide",
	"Chlortetracycline Hydrochloride (Chlortetracycline Calcium Complex)",
	"Arsenic Trioxide",
	"Pantoprazole (Pantoprazole Magnesium Hemipentahydrate)",
	"Cisatracurium (Cisatracurium Besylate)",
	"Guanfacine (Guanfacine Hydrochloride)",
	"Vismodegib",
	"Dabrafenib (Dabrafenib Mesylate)",
	"Trametinib",
	"Aclidinium Bromide",
	"Idarubicin Hydrochloride",
	"Iodine (Polyoxypropylene-Polyoxyethylene Block Copolymer-Iodine Complex)",
	"Rifaximin",
	"Sinecatechins",
	"Pergolide (Pergolide Mesylate)",
	"Trastuzumab Emtansine",
	"Galsulfase",
	"Riociguat",
	"Pasireotide (Pasireotide Diaspartate)",
	"Efinaconazole",
	"Romidepsin",
	"Dolutegravir (Dolutegravir Sodium)",
	"Insulin Biosynthetic Human Br",
	"Meropenem",
	"Difluprednate",
	"Afatinib (Afatinib Dimaleate)",
	"Macitentan",
	"Aflibercept",
	"Teriflunomide",
	"Modified Vaccinia Virus (Ankara-Bavarian Nordic)",
	"Tacrolimus (Tacrolimus Monohydrate)",
	"L-Lactic Acid",
	"Outer Membrane Vesicles (Neisseria Meningitidis Group B Nz98/254 Strain)",
	"Eptacog Alfa (Activated)",
	"Linaclotide",
	"Alogliptin (Alogliptin Benzoate)",
	"Sofosbuvir",
	"Radium Ra-223 Dichloride",
	"Umeclidinium (Umeclidinium Bromide)",
	"Factor Xiii",
	"Bosutinib (Bosutinib Monohydrate)",
	"Malt",
	"Pomalidomide",
	"Calcium Hypochlorite",
	"Lomitapide (Lomitapide Mesylate)",
	"Haemagglutinin-Strain B (Yamagata)",
	"Iodine (Polyethoxy Polypropoxy Polyethoxy Ethanol - Iodine Complex)",
	"Avilamycin",
	"Brimonidine (Brimonidine Tartrate)",
	"Recombinant Human Coagulation Factor Ix, Fc Fusion Protein",
	"Standardized Short Ragweed Pollen Allergenic Extract",
	"Esomeprazole (Esomeprazole Magnesium Dihydrate)",
	"Tofacitinib (Tofacitinib Citrate)",
	"Triptorelin (Triptorelin Acetate)",
	"Fluralaner",
	"Canagliflozin",
	"Taliglucerase Alfa",
	"Icatibant (Icatibant Acetate)",
	"Sterile Water",
	"Chlorine Dioxide",
	"Frovatriptan (Frovatriptan Succinate Monohydrate)",
	"Influenza Virus Type B (Yamagata)",
	"Eslicarbazepine Acetate",
	"Elosulfase Alfa",
	"Afoxolaner",
	"Oclacitinib (Oclacitinib Maleate)",
	"Methyl Salicylate",
	"Peppermint Oil",
	"Antihemophilic Factor (Recombinant Bdd), Fc Fusion Protein",
	"Narasin",
	"Nonacog Gamma",
	"Ledipasvir",
	"Bazedoxifene (Bazedoxifene Acetate)",
	"Azelastine Hydrochloride",
	"Vortioxetine (Vortioxetine Hydrobromide)",
	"Cefotaxime Sodium",
	"Apremilast",
	"Ibrutinib",
	"Obinutuzumab",
	"Oxaliplatin",
	"Siltuximab",
	"Turoctocog Alfa",
	"Prilocaine Hydrochloride",
	"Dapagliflozin (Dapagliflozin Propanediol Monohydrate)",
	"Ulipristal Acetate",
	"Deferiprone",
	"Hexaminolevulinate Hydrochloride",
	"Sodium Phenylbutyrate",
	"Pradofloxacin",
	"Ceritinib",
	"Vedolizumab",
	"Recombinant Human Papillomavirus Type 58 L1 Protein",
	"Bemotrizinol",
	"Pasireotide (Pasireotide Pamoate)",
	"Ponatinib (Ponatinib Hydrochloride)",
	"Iodophor",
	"Ceftazidime (Ceftazidime Pentahydrate)",
	"Secukinumab",
	"Palivizumab",
	"Terbinafine",
	"Pemetrexed (Pemetrexed Disodium Hemipentahydrate)",
	"Tesamorelin (Tesamorelin Acetate)",
	"Idelalisib",
	"Bromfenac (Bromfenac Sodium Sesquihydrate)",
	"Carglumic Acid",
	"Clodronate Disodium (Clodronate Disodium Tetrahydrate)",
	"Levomilnacipran (Levomilnacipran Hydrochloride)",
	"Ergonovine Maleate",
	"Zinc (Zinc Diammonium Edta)",
	"Sodium Pertechnetate Tc-99m",
	"Olodaterol (Olodaterol Hydrochloride)",
	"Naloxegol (Naloxegol Oxalate)",
	"Varicella Zoster Immunoglobulin (Human)",
	"Nintedanib (Nintedanib Esilate)",
	"Vilazodone Hydrochloride",
	"Ramucirumab",
	"Deoxycholic Acid",
	"Empagliflozin",
	"Vilanterol (Vilanterol Trifenatate)",
	"Peginterferon Beta-1a",
	"Asfotase Alfa",
	"Teduglutide",
	"Evolocumab",
	"Nivolumab",
	"Ceftobiprole (Ceftobiprole Medocaril Sodium)",
	"Sacubitril (Sacubitril Valsartan Sodium Hydrate Complex)",
	"Antihemophilic Factor (Recombinant) Porcine Sequence",
	"Dulaglutide",
	"Entecavir (Entecavir Monohydrate)",
	"Closantel (Closantel Sodium)",
	"Betamethasone Valerate",
	"Mepolizumab",
	"Mometasone Furoate (Mometasone Furoate Monohydrate)",
	"Blinatumomab",
	"Lenvatinib (Lenvatinib Mesylate)",
	"Carfilzomib",
	"Grazoprevir",
	"Selexipag",
	"Coagulation Factor Ix (Recombinant), Albumin Fusion Protein (Rix-Fp)",
	"Lumacaftor",
	"Perindopril Arginine",
	"Sugammadex (Sugammadex Sodium)",
	"Sarolaner",
	"Octyl Dimethyl Ammonium Chloride",
	"Cobimetinib (Cobimetinib Fumarate)",
	"Chlorhexidine (Chlorhexidine Digluconate)",
	"Brivaracetam",
	"Palbociclib",
	"Eszopiclone",
	"Glycerol Phenylbutyrate",
	"Alirocumab",
	"Bilastine",
	"Escitalopram",
	"Abamectin",
	"Idarucizumab",
	"Olaparib",
	"Tenofovir Alafenamide (Tenofovir Alafenamide Hemifumarate)",
	"Ixekizumab",
	"Daratumumab",
	"Sodium Glycerophosphate",
	"Osimertinib (Osimertinib Mesylate)",
	"Velpatasvir",
	"Reslizumab",
	"Rupatadine (Rupatadine Fumarate)",
	"Bepotastine Besilate",
	"Ixazomib (Ixazomib Citrate)",
	"Pembrolizumab",
	"Calcipotriol (Calcipotriol Monohydrate)",
	"Nitisinone",
	"Propranolol (Propranolol Hydrochloride)",
	"Venetoclax",
	"Alectinib (Alectinib Hydrochloride)",
	"Edoxaban (Edoxaban Tosylate Monohydrate)",
	"Antihemophilic Factor (Recombinant), Pegylated",
	"Apomorphine Hydrochloride",
	"Gadoterate Meglumine",
	"Acetylcysteine",
	"Ivabradine (Ivabradine Hydrochloride)",
	"Propiverine Hydrochloride",
	"Canakinumab",
	"Sarilumab",
	"Eluxadoline",
	"Brexpiprazole",
	"Pegaspargase",
	"Florbetaben (18f)",
	"Ethacrynic Acid (Ethacrynate Sodium)",
	"Vernakalant Hydrochloride",
	"Thiotepa",
	"Atezolizumab",
	"Obeticholic Acid",
	"Eliglustat (Eliglustat Tartrate)",
	"Ozenoxacin",
	"Vardenafil (Vardenafil Hydrochloride Trihydrate)",
	"Lixisenatide",
	"Cysteamine (Cysteamine Bitartrate)",
	"Peforelin (Peforelin Acetate)",
	"Daptomycin",
	"Nusinersen (Nusinersen Sodium)",
	"Defibrotide",
	"Febuxostat (Febuxostat Hemihydrate)",
	"Haptens",
	"Desvenlafaxine",
	"Irinotecan (Irinotecan Sucrose Octasulfate)",
	"Ocrelizumab",
	"Cefepime (Cefepime Hydrochloride)",
	"Voxilaprevir",
	"Glecaprevir",
	"Insulin Degludec",
	"Migalastat (Migalastat Hydrochloride)",
	"Varicella-Zoster Virus Glycoprotein E Antigen",
	"Netupitant",
	"Neisseria Meningitidis Grp B Recombinant Lipoprotein 2086 Subfamily B",
	"Durvalumab",
	"Letermovir",
	"Sebelipase Alfa",
	"Avelumab",
	"Guselkumab",
	"Coagulation Factor Ix (Recombinant), Pegylated",
	"Dupilumab",
	"Yttrium-90 Chloride",
	"Ioflupane (123i)",
	"Triamcinolone Hexacetonide",
	"Dasatinib",
	"Lifitegrast",
	"Lotilaner",
	"Semaglutide",
	"Iron (Sucroferric Oxyhydroxide)",
	"Tipiracil (Tipiracil Hydrochloride)",
	"Immunoglobulin G (Human)",
	"Benralizumab",
	"Flibanserin",
	"Ribociclib (Ribociclib Succinate)",
	"Brodalumab",
	"Inotuzumab Ozogamicin",
	"Cidofovir (Cidofovir Dihydrate)",
	"Follitropin Delta",
	"Methoxyflurane",
	"Buprenorphine Hydrochloride",
	"Edaravone",
	"Crisaborole",
	"Iron (Iron Isomaltoside 1000)",
	"Sodium Iodide 123 I",
	"Apalutamide",
	"Calcium Hypophosphite",
	"Hemin",
	"Brigatinib",
	"Erenumab",
	"Emicizumab",
	"Baricitinib",
	"Prabotulinumtoxina",
	"Tisagenlecleucel",
	"Cabozantinib (Cabozantinib Malate)",
	"Lanadelumab",
	"Elagolix (Elagolix Sodium)",
	"Patiromer (Patiromer Sorbitex Calcium)",
	"Inotersen (Inotersen Sodium)",
	"Doravirine",
	"Telotristat Ethyl (Telotristat Etiprate)",
	"Antihemophilic Factor (Recombinant, B-Domain Deleted, Pegylated)",
	"Pralatrexate",
	"Iodine (Alkoxypolyethoxyethanol Iodized Complex)",
	"Dinutuximab",
	"Mupirocin (Mupirocin Calcium)",
	"Burosumab",
	"Isavuconazole (Isavuconazonium Sulfate)",
	"Cerliponase Alfa",
	"Latanoprostene Bunod",
	"Grapiprant",
	"Lutetium (177lu) Oxodotreotide",
	"Safinamide (Safinamide Mesylate)",
	"Fluorouracil (Fluorouracil Sodium)",
	"Enasidenib (Enasidenib Mesylate)",
	"Cysteamine (Cysteamine Hydrochloride)",
	"Axicabtagene Ciloleucel",
	"Lorlatinib",
	"Disofenin",
	"Tetrasodium Pyrophosphate",
	"Dacomitinib (Dacomitinib Monohydrate)",
	"Darunavir (Darunavir Propylene Glycolate)",
	"Teriparatide (Teriparatide Acetate)",
	"Capsaicin",
	"Abemaciclib",
	"Cemiplimab",
	"Darunavir",
	"Risankizumab",
	"Iodine (Alkyl Poly Ethoxy Ethanol - Iodine Complex)",
	"Fosfomycin (Fosfomycin Sodium)",
	"Tibolone",
	"Patisiran (Patisiran Sodium)",
	"Romosozumab",
	"Niraparib (Niraparib Tosylate)",
	"Oxodotreotide",
	"Larotrectinib (Larotrectinib Sulfate)",
	"Neratinib (Neratinib Maleate)",
	"Sodium Zirconium Cyclosilicate",
	"Galcanezumab",
	"Hydroquinone",
	"Acalabrutinib",
	"Glucagon",
	"Gallium 68 Ga Chloride",
	"Erdafitinib",
	"Trifarotene",
	"Gemtuzumab Ozogamicin",
	"Entrectinib",
	"Gilteritinib (Gilteritinib Fumarate)",
	"Upadacitinib",
	"Icosapent Ethyl",
	"Tafamidis Meglumine",
	"Amoxicillin (Amoxicillin Sodium)",
	"Caplacizumab",
	"Darolutamide",
	"Siponimod",
	"Caffeine Citrate",
	"Brolucizumab",
	"Alpelisib",
	"Cabotegravir (Cabotegravir Sodium)",
	"Rilpivirine",
	"Cabotegravir",
	"Zinc (Zinc Chloride)",
	"Fremanezumab",
	"Tenapanor (Tenapanor Hydrochloride)",
	"Standardized Allergen Extract, White Birch (Betula Verrucosa)",
	"Isatuximab",
	"L-Valine",
	"Glasdegib (Glasdegib Maleate)",
	"Etomidate",
	"Lanthanum (Lanthanum Carbonate Dihydrate)",
	"Esketamine (Esketamine Hydrochloride)",
	"Etonogestrel",
	"Polatuzumab Vedotin",
	"Satralizumab",
	"Tucatinib",
	"Sonidegib (Sonidegib Phosphate)",
	"Ripretinib",
	"Decitabine",
	"Remdesivir",
	"Amifampridine (Amifampridine Phosphate)",
	"Amifampridine",
	"Trientine Hydrochloride",
	"Luspatercept",
	"Ozanimod (Ozanimod Hydrochloride)",
	"Givosiran (Givosiran Sodium)",
	"Lemborexant",
	"Fostamatinib (Fostamatinib Disodium)",
	"Bamlanivimab",
	"Tozinameran",
	"Mrna-1273 Sars-Cov-2"
]